import { api } from "../../../../utils/services/api";

export function concreteBending(data) {
  return api.post("/calculator/concrete/bending", data);
}

export function concreteShear(data) {
  return api.post("/calculator/concrete/shear", data);
}

export function concreteTorsion(data) {
  return api.post("/calculator/concrete/torsion", data);
}

export function concreteShearTorsion(data) {
  return api.post("/calculator/concrete/shear-torsion", data);
}

export function concreteAnchorageLength(data) {
  return api.post("/calculator/concrete/anchorage-length", data);
}

export function concreteSplice(data) {
  return api.post("/calculator/concrete/splice", data);
}

export function concreteFatigue(data) {
  return api.post("/calculator/concrete/fatigue", data);
}

export function steelTension(data) {
  return api.post("/calculator/steel/tension", data);
}

export function timberTension(data) {
  return api.post("/calculator/timber/tension", data);
}

export function timberCompression(data) {
  return api.post("/calculator/timber/compression", data);
}

export function timberShear(data) {
  return api.post("/calculator/timber/shear", data);
}

export function timberBending(data) {
  return api.post("/calculator/timber/bending", data);
}

export function timberBendingCombined(data) {
  return api.post("/calculator/timber/bending-combined", data);
}
